var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shop-page"}},[(!_vm.showShop)?_c('ComingSoon'):_vm._e(),(_vm.showShop)?_c('store-homepage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }